export default {
    GET_POST_LIST: 'GET_POST_LIST',
    GET_POST: 'GET_POST',
    GET_LATEST_VIDEO: 'GET_LATEST_VIDEO',
    GET_LATEST_POSTS: 'GET_LATEST_POSTS',
    GET_TAGS: 'GET_TAGS'
}
